export default "__VITE_ASSET__Ok4b5oJ0__"